import { render, staticRenderFns } from "./panels.vue?vue&type=template&id=1b0bc66c"
import script from "./panels.vue?vue&type=script&lang=js"
export * from "./panels.vue?vue&type=script&lang=js"
import style0 from "./panels.vue?vue&type=style&index=0&id=1b0bc66c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports